"use strict";

(function () {

    $.widget('khis.patientSelector', {
        options: {
            label: 'Utente',
            width: '353',
            disabled: false
        },
        inputWidth: 240,
        patientId: null,
        disabled: false,
        _create: function () {
            this.inputWidth = this.options.width-113;

            this.element
                .addClass('form_elem bootstrap')
                .css('width', this.options.width+'px');

            this._drawComponent();

            if(this.disabled){
                this.inputElem.attr('disabled', 'disabled');
                this.searchBtn.hide();
                this.clearBtn.hide();
                this.createBtn.hide();
            }
        },
        _init: function () {
            this.patientId = null;
            this.disabled = this.options.disabled;

            this.initializeAutoSearch();

            this._on({
                'click button[role=search]': function () {
                    this.openSearchModal();
                }
            });

            this._on({
                'click button[role=clear]': function () {
                    this.updatePatient();
                }
            });

            this._on({
                'click button[role=add]': function () {
                    Hades.loadScreen('/patients/new_patient', {go_back:1, patient_name:this.inputElem.val()});
                }
            });
        },
        _drawComponent: function() {
            this.labelElem = $('<div class="form_label form_label_mandatory"><label for="patient_name">'+this.options.label+'</label></div>');
            this.container = $('<div style="position: relative; height: 30px; width: '+this.options.width+'px;"></div>');

            this.warningsElem = $('<div role="warnings" style="position: absolute; left: 0px; top: 0px; width: 14px; height: 28px; background-color: #EEE; border-left: solid 1px rgb(169, 217, 224); border-top: solid 1px rgb(169, 217, 224); border-bottom: solid 1px rgb(169, 217, 224);"></div>');
            this.warningsCircleElem = $('<div style="margin-left: 2px; margin-top: 10px;" class="circle_12x12 gray_circle"></div>');
            this.warningsElem.append(this.warningsCircleElem);

            this.photoElem = $('<div style="position: absolute; left: 14px; top: 0px;"><img role="patient_photo" src="/assets/photo_unknown.png" class="photo"></div>');
            this.inputElem = $('<input type="text" value="" name="patient_name" style="position: absolute; left: 44px; top: 0px; width:'+this.inputWidth+'px;" class="input_grad form_field_mandatory" role="patient_name">');

            this.searchBtn = $('<button role="search" type="button" class="square_btn search_square_btn" tabindex="-1" style="position: absolute; left: '+(this.inputWidth+53)+'px; top: 0px;"></button>');
            this.clearBtn = $('<button role="clear" type="button" class="square_btn close_square_btn_red" tabindex="-1" style="display: none; position: absolute; left: '+(this.inputWidth+53)+'px; top: 0px;"></button>');
            this.createBtn = $('<button role="add" type="button" class="square_btn add_square_btn" tabindex="-1"  style="position: absolute; left: '+(this.inputWidth+82)+'px; top: 0px;"></button>');

            this.element.append(this.labelElem);
            this.container.append(this.warningsElem);
            this.container.append(this.photoElem);
            this.container.append(this.inputElem);
            this.container.append(this.searchBtn);
            this.container.append(this.clearBtn);
            this.container.append(this.createBtn);

            this.element.append(this.container);
        },
        initializeAutoSearch: function(){
            var that = this;

            this.inputElem.autocomplete({
                search: function(event, ui) {
                    Hades.showLoading();
                },
                source:function (request, response) {
                    $.ajax({
                        url:"/patients/search_autocomplete",
                        dataType:"jsonp",
                        data:{
                            featureClass:"P",
                            style:"full",
                            maxRows:12,
                            name_startsWith:request.term
                        },
                        success:function (data) {
                            that.patientId = null;
                            that.photoElem.find('[role=patient_photo]').attr('src', '/assets/photo_unknown.png');

                            Hades.hideLoading();

                            response($.map(data, function (item) {
                                return {
                                    label:item.name + (item.nnu ? ", NNU: " + item.nnu : ""),
                                    value:item.name,
                                    photo:item.photo,
                                    id:item.id
                                }
                            }));
                        },
                        error:function (xhr, status, error) {
                            Hades.showError(error, xhr.responseText, xhr, status, error);
                            Hades.hideLoading();
                        }
                    });
                },
                minLength:2,
                select:function (event, ui) {
                    if (ui.item) {
                        that.updatePatient({id:ui.item.id, photo: ui.item.photo, name:ui.item.value});
                    }
                },
                open:function () {
                    $(this).removeClass("ui-corner-all").addClass("ui-corner-top");
                },
                close:function () {
                    $(this).removeClass("ui-corner-top").addClass("ui-corner-all");
                }
            });
        },
        openSearchModal: function () {
            var that = this;

            Hades.showLoading();

            $.get('/patients/search_modal', {search:$('#patient_name').val(), width:$(window).width(), height:$(window).height()}, null, "html")
                .done(function (data, status, xhr) {
                    Hades.checkIfUserIsAuthorized(data, status, xhr);

                    $.fancybox({content:data, autoScale:true, autoDimensions:true});

                    $('#patient-search-modal-ct').bind('patientSelected', function (evt, data){that.onPatientSelected(evt, data, {id:that.element.attr('id')});});

                    Hades.hideLoading();
                })
                .fail(function (xhr, status, error) {
                    Hades.showError(error, xhr.responseText, xhr, status, error);
                    Hades.hideLoading();
                });
        },
        onPatientSelected: function(event, data, params) {
            $.fancybox.close(true);

            $('#'+params.id).patientSelector('updatePatient', data);
        },
        updatePatient: function(data){
            if(data){
                this.patientId = data.id;
                this.photoElem.find('[role=patient_photo]').attr('src', data.photo);
                this.inputElem.val(GlobalFn.toPlainString(data.name)).attr('disabled', 'disabled');
                this.inputElem.attr('title',GlobalFn.toPlainString(data.name));

                if(this.disabled){
                    this.searchBtn.hide();
                    this.clearBtn.hide();
                    this.createBtn.hide();
                } else {
                    this.searchBtn.hide();
                    this.clearBtn.show();
                }

                Hades.getPatientWarnings(this.patientId, this.warningsElem);
            } else {
                this.patientId = null;

                this.photoElem.find('[role=patient_photo]').attr('src', '/assets/photo_unknown.png');
                this.inputElem.val(null);

                if(this.disabled){
                    this.inputElem.attr('disabled', 'disabled');
                    this.searchBtn.hide();
                    this.clearBtn.hide();
                    this.createBtn.hide();
                } else {
                    this.inputElem.removeAttr('disabled');
                    this.clearBtn.hide();
                    this.searchBtn.show();
                }
            }
        },
        getPatientInfo: function(){
            return {
                id: this.patientId,
                name: this.inputElem.val()
            }
        }
    });

})();